<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <div class="container-width">
      <div class="slide">
        <h3><i class="el-icon-user-solid"></i> 个人中心</h3>
        <ul>
          <li @click="curTab = 1" :class="{'action': curTab === 1}">用户信息</li>
          <li @click="curTab = 2" :class="{'action': curTab === 2}">认证证书</li>
          <li @click="curTab = 3" :class="{'action': curTab === 3}">培训记录</li>
          <li @click="curTab = 4" :class="{'action': curTab === 4}">执裁记录</li>
          <li @click="curTab = 5" :class="{'action': curTab === 5}">学习中心</li>
        </ul>
      </div>
      <div class="h5-slide">
        <h3><i class="el-icon-user-solid"></i> 个人中心</h3>
        <ul>
          <li @click="curTab = 1" :class="{'action': curTab === 1}">用户信息</li>
          <li @click="curTab = 2" :class="{'action': curTab === 2}">认证证书</li>
          <li @click="curTab = 3" :class="{'action': curTab === 3}">培训记录</li>
          <li @click="curTab = 4" :class="{'action': curTab === 4}">执裁记录</li>
          <li @click="curTab = 5" :class="{'action': curTab === 5}">学习中心</li>
        </ul>
      </div>
      <div class="userinfo" v-if="curTab === 1">
        <div class="title">用户信息</div>
        <ul class="user">
          <li>
            <label>用户名：</label>
            <span class="blue">
              {{info.name}}
              <span v-if="info.refereeDto">（{{ info.refereeDto.sex | filterSex }}）</span>
               &nbsp;
            </span>
            <span class="green" v-if="info.certStatus === 1">
              已认证
              <img src="../../../../assets/images/icon2.png" />
            </span>
            <span v-else style="color: #999">
              未认证
            </span>
          </li>
          <template v-if="info.refereeDto">
            <li>
              <label>用户头像：</label>
              <div class="avtar">
                <el-image class="img" :src="info.refereeDto.picUrl">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="edit">
                  <el-upload
                    :action="uploadUrl"
                    accept="image/*"
                    :on-success="uploadSuccessHandler"
                    :multiple="false">
                    <!-- <i class="el-icon-upload"></i> -->
                    <i class="el-icon-edit-outline"></i>
                  </el-upload>
                </div>
              </div>
            </li>
            <li>
              <label>手机号码：</label>
              <span class="line">{{ info.refereeDto.phone }}</span>
            </li>
            <li>
              <label>邮箱：</label>
              <span class="line">
                {{ info.refereeDto.email }}
              </span>
            </li>
            <li>
              <label>身份证号：</label>
              <span class="line">{{ info.refereeDto.idCard }}</span>
            </li>
            <li>
              <label>裁判证编号：</label>
              <span class="line">
                {{ info.refereeDto.refereeCard }}
              </span>
            </li>
            <li>
              <label>裁判小项：</label>
              <span class="line">
                {{ info.refereeDto.refereeItems}}
              </span>
            </li>
            <li>
              <label>注册单位：</label>
              <span class="line">
                {{ info.refereeDto.registerUnit }}
              </span>
            </li>
            <li>
              <label>裁判级别：</label>
              <span class="line">
                {{ info.refereeDto.refereeLevel }}
              </span>
            </li>
          </template>
        </ul>
        <span class="out-log mouse" @click="logOut">退出登录</span>
      </div>
      <!-- 2 -->
      <div class="userinfo" v-if="curTab === 3">
        <div class="title">裁判员培训记录</div>
        <div class="table">
          <div class="list" v-if="pageInfo.total > 0">
            <el-table
              :data="list"
              stripe
              style="margin: 24px 0 24px 0; width: 100%">
              <el-table-column
                prop="trainName"
                label="培训名称"
                min-width="180">
              </el-table-column>
              <el-table-column
                prop="trainAddress"
                label="培训地址"
                min-width="160">
              </el-table-column>
              <el-table-column
                prop="date"
                label="培训时间"
                min-width="160">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.trainStartTime ? formatDate(Date.parse(scope.row.trainStartTime), 'YYYY-mm-dd') : '' }}
                    ~
                    {{ scope.row.trainEndTime ? formatDate(Date.parse(scope.row.trainEndTime), 'YYYY-mm-dd') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                width="120">
                <template slot-scope="scope">
                  <div>
                    <el-tag v-if="scope.row.status == 3" type="success">优秀</el-tag>
                    <el-tag v-else-if="scope.row.status == 1" type="success">合格</el-tag>
                    <el-tag v-else-if="scope.row.status == 0" type="danger">不合格</el-tag>
                    <el-tag v-else type="info">其他</el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="empty">
            暂无记录
          </div>
        </div>
        <div class="h5-list">
          <div v-if="list.length">
            <div class="item" v-for="(item, index) in list" :key="index">
              <div class="h3">
                <span>{{ item.trainName || '--' }}</span>
                <el-tag v-if="item.status == 3" type="success">优秀</el-tag>
                <el-tag v-else-if="item.status == 1" type="success">合格</el-tag>
                <el-tag v-else-if="item.status == 0" type="danger">不合格</el-tag>
                <el-tag v-else type="info">其他</el-tag>
              </div>

              <div class="content">
                <span class="label">培训地址：</span>{{ item.trainAddress || '--' }}
              </div>
              <div class="content">
                <span class="label">培训时间：</span>
                <span v-if="item.trainStartTime && item.trainEndTime">
                  {{ item.trainStartTime ? formatDate(Date.parse(item.trainStartTime), 'YYYY-mm-dd') : '' }} ~ {{ item.trainEndTime ? formatDate(Date.parse(item.trainEndTime), 'YYYY-mm-dd') : '' }}
                </span>
                <span v-else>--</span>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            暂无记录
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :page-size="pageInfo.pageSize"
            :total="pageInfo.total">
          </el-pagination>
        </div>
      </div>
      <!-- 3 -->
      <div class="userinfo" v-if="curTab === 2">
        <div class="title">认证证书</div>
        <div class="box" v-if="info.refereeDto"  style="text-align: center; padding-bottom: 48px;">
          <div class="a-pic" ref="imageWrapper">
            <div class="wrapper">
              <div class="t1">经协会审核认定：</div>
              <div class="h3">
                <!-- <b>{{info.name}}</b>&nbsp;为&nbsp;<b>{{ info.refereeDto.refereeLevel }}</b>&nbsp;级排球裁判员 <br />
                上海市排球协会会员 -->
                <b>{{info.name}}</b>&nbsp;为排球项目国家&nbsp;<b>{{ info.refereeDto.refereeLevel }}</b>&nbsp;级裁判员 <br />
                上海市排球协会会员
              </div>
              <div class="t2">特发此证</div>
              <div class="logo">
                <img src="../../../../assets/images/logo__1.png" />
              </div>
              <div class="z">
                <img src="../../../../assets/images/z.png" />
              </div>
              <div class="mun">
                <span class="n1">
                  编号: {{ info.refereeDto.refereeCard }}
                </span>
                <span class="n2">
                  日期: {{ info.refereeDto.certificateStartTime ? formatDate(Date.parse(info.refereeDto.certificateStartTime), 'YYYY.mm.dd') : '' }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="ticketPic">
            <img :src="ticketPic" width="600" />
          </div>
        </div>
        <div v-else class="empty">
          暂无记录
        </div>
      </div>
      <!-- 4 -->
      <div class="userinfo" v-if="curTab === 4">
        <div class="title">执裁记录</div>
        <div class="table">
          <div class="list" v-if="pageInfo4.total > 0">
            <el-table
              :data="list4"
              stripe
              style="margin: 24px 0 24px 0; width: 100%">
              <el-table-column
                prop="trainName"
                label="比赛名称"
                min-width="180">
              </el-table-column>
              <el-table-column
                prop="trainAddress"
                label="比赛地址"
                min-width="160">
              </el-table-column>
              <el-table-column
                prop="date"
                label="比赛时间"
                min-width="160">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.trainStartTime ? formatDate(Date.parse(scope.row.trainStartTime), 'YYYY-mm-dd') : '' }}
                    ~
                    {{ scope.row.trainEndTime ? formatDate(Date.parse(scope.row.trainEndTime), 'YYYY-mm-dd') : '' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                width="120">
                <template slot-scope="scope">
                  <div>
                    <el-tag v-if="scope.row.status == 3" type="success">优秀</el-tag>
                    <el-tag v-else-if="scope.row.status == 1" type="success">合格</el-tag>
                    <el-tag v-else-if="scope.row.status == 0" type="danger">不合格</el-tag>
                    <el-tag v-else type="info">其他</el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="empty">
            暂无记录
          </div>
        </div>
        <div class="h5-list">
          <div v-if="pageInfo4.total > 0">
            <div class="item" v-for="(item, index) in list4" :key="index">
              <div class="h3">
                <span>{{ item.trainName }}</span>
                <el-tag v-if="item.status == 3" type="success">优秀</el-tag>
                <el-tag v-else-if="item.status == 1" type="success">合格</el-tag>
                <el-tag v-else-if="item.status == 0" type="danger">不合格</el-tag>
                <el-tag v-else type="info">其他</el-tag>
              </div>

              <!-- <div class="content">{{ item.trainName }}</div> -->
              <div class="content">
                <span class="label">比赛地址：</span>{{ item.trainAddress }}
              </div>
              <div class="content">
                <span class="label">比赛时间：</span>{{ item.trainStartTime ? formatDate(Date.parse(item.trainStartTime), 'YYYY-mm-dd') : '' }} ~ {{ item.trainEndTime ? formatDate(Date.parse(item.trainEndTime), 'YYYY-mm-dd') : '' }}
              </div>
            </div>
          </div>
          <div v-else class="empty">
            暂无记录
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange4"
            :page-size="pageInfo4.pageSize"
            :total="pageInfo4.total">
          </el-pagination>
        </div>
      </div>
      <!-- 5 学习中心 -->
      <div class="userinfo" v-if="curTab === 5">
        <div class="title">学习中心</div>
        <div class="study-wrap">
          <div class="study-tip" v-if="studyLoaded">
            共 {{ pageInfo5.total }} 个课程，完成全部视频学习并通过考试即可获得「已完成」标识。
          </div>
          <div class="course-card mouse"
            v-for="c in studyCourses"
            :key="c.id"
            @click="goCourse(c.id)">
            <div class="cc-cover" v-if="c.coverImg">
              <el-image :src="c.coverImg" fit="cover">
                <div slot="error" class="cc-cover-err"><i class="el-icon-picture-outline"></i></div>
              </el-image>
              <el-tag v-if="c.done" type="success" effect="dark" size="small" class="cc-cover-tag">已完成</el-tag>
              <el-tag v-else type="warning" effect="dark" size="small" class="cc-cover-tag">进行中</el-tag>
            </div>
            <div class="cc-head">
              <span class="cc-name">{{ c.courseName || '--' }}</span>
              <el-tag v-if="c.done" type="success" effect="dark" size="small">已完成</el-tag>
              <el-tag v-else type="warning" effect="plain" size="small">进行中</el-tag>
            </div>
            <div class="cc-lecturer" v-if="c.lecturer">
              <i class="el-icon-user"></i> 讲师：{{ c.lecturer }}
            </div>
            <div class="cc-meta" v-if="c.startTime || c.endTime">
              <i class="el-icon-time"></i>
              {{ c.startTime ? formatDate(Date.parse(c.startTime), 'YYYY-mm-dd') : '' }}
              ~
              {{ c.endTime ? formatDate(Date.parse(c.endTime), 'YYYY-mm-dd') : '' }}
            </div>
            <div class="cc-body">
              <div class="cc-item">
                <span class="label">视频学习</span>
                <el-tag v-if="c.totalNum === 0" type="info" size="mini">暂无视频</el-tag>
                <template v-else>
                  <el-tag :type="c.videoDone ? 'success' : 'info'" size="mini">
                    {{ c.videoDone ? '已学完' : '学习中' }}
                  </el-tag>
                  <span class="num">{{ c.watchedNum }}/{{ c.totalNum }}</span>
                  <el-progress class="bar" :percentage="c.progress" :show-text="false" :stroke-width="6" :color="'#4c2ac9'"></el-progress>
                </template>
              </div>
              <div class="cc-item">
                <span class="label">课程考试</span>
                <el-tag v-if="c.latestPassFlag === 1" type="success" size="mini">已通过</el-tag>
                <el-tag v-else-if="c.latestPassFlag === 0" type="danger" size="mini">未通过</el-tag>
                <el-tag v-else type="info" size="mini">未考试</el-tag>
                <span class="num" v-if="c.attemptCount > 0">最近 {{ c.latestScore }} 分 · 已考 {{ c.attemptCount }} 次</span>
              </div>
            </div>
            <div class="cc-foot">
              <span>进入学习 <i class="el-icon-arrow-right"></i></span>
              <el-button
                v-if="c.done"
                size="mini"
                type="success"
                plain
                @click.stop="goCertificate(c.id)">
                <i class="el-icon-medal"></i> 培训证书
              </el-button>
            </div>
          </div>
          <div v-if="studyLoaded && !studyCourses.length" class="empty">暂无可学习的课程</div>
          <div class="pagination-box" v-if="pageInfo5.total > pageInfo5.pageSize">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="currentChange5"
              :page-size="pageInfo5.pageSize"
              :total="pageInfo5.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { getAccountDetail, getTrainDetailPage, updateReferee, getJudgmentDetailPage } from '@/service/apis/userinfo'
import { getStudyCourseList, getStudyUserPassStatus, getStudyCourseSummary } from '@/service/apis/study'
import { getBanner } from '@/service/apis/common'
import html2canvas from 'html2canvas'

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'UserInfo',
  data () {
    return {
      uploadUrl: 'http://150.158.91.235:8001/api/upload/uploadImage', // 上传URL
      banner: [],
      ticketPic: '',
      pageInfo: {
        pageIndex: 1,
        pageSize: 10
      },
      pageInfo4: {
        pageIndex: 1,
        pageSize: 10
      },
      accout: null,
      info: {
        certStatus: '',
        sex: '',
        name: '',
        phone: '',
        email: '',
        headImage: '',
        idCard: '',
        refereeDto: null
      },
      list: [],
      list4: [],
      studyCourses: [],
      studyLoaded: false,
      pageInfo5: {
        pageIndex: 1,
        pageSize: 10
      },
      curTab: 1, // 1 用户信息 2认证证书 3培训记录 4执裁记录 5学习中心
    }
  },
  watch: {
    curTab (val) {
      if (val === 2) {
        if (this.ticketPic === '') {
          this.toPic()
        }
      }
      if (val === 5 && !this.studyLoaded) {
        this.studyLoaded = true
        this.getStudyList()
      }
    }
  },
  filters: {
    filterSex (sex) {
      switch(sex) {
        case 1:
          return '男'
        case 2:
          return '女'
          break
        default :
          return '未知'
      }
    },
    filterStatus (status) {
      switch (status) {
        case 1:
          return '合格'
        case 0:
          return '不合格'
        default:
          return '其他'
      }
    }
  },
  created () {
    let account = localStorage.getItem('ACCOUNT')
      if (!account) {
        this.$router.replace('/login')
      } else {
        getBanner(this).then(data => {
          // 会员专区banner 11
          if (data[11]) {
            this.banner = [...data[11]]
          }
        })
        account = JSON.parse(account)
        this.account = account
        if (typeof account.id !== 'undefined' && account.id) {
          // 获取个人信息
          this.getDetail(account.id);
          // 获取培训记录
          this.getTrainList()
          // 执裁记录
          this.getAdjudicateList()
        } else {
          this.$router.replace('/login')
        }

      }
  },
  methods: {
    uploadSuccessHandler (resp) {
      const errCode = resp.errCode
      if (errCode === 0) {
        // 图片地址
        this.info.refereeDto.picUrl = resp.data
        this.updateRefereeHandle()
      } else if (resp.errCode === 9994) {
        this.$message({
          type: 'error',
          message: resp.errMsg || '登录失效',
          onClose: () => {
            localStorage.clear()
            this.$router.replace('/login')
          }
        })
      } else {
        this.$message.error(resp.errMsg || '上传失败')
      }
    },
    updateRefereeHandle () {
      if (this.info.refereeDto) {
        updateReferee.call(this, this.info.refereeDto).then(res => {
          if (res.errCode === 0) {
            this.$message.success('修改头像成功!')
          } else if (res.errCode === 9994) {
            this.$message({
              type: 'error',
              message: res.errMsg || '登录失效',
              onClose: () => {
                localStorage.clear()
                this.$router.replace('/login')
              }
            })
          }
        })
      }
    },
    toPic () {
      this.$nextTick(() => {
        html2canvas(this.$refs.imageWrapper).then(canvas => {
        let dataURL = canvas.toDataURL('image/png');
        this.ticketPic = [dataURL]
          // console.log(dataURL)
        })
      })
    },
    // 退出登录
    logOut () {
      localStorage.clear()
      this.$router.replace('/login')
    },
    // 获取个人信息
    getDetail (id) {
      getAccountDetail.call(this, { id }).then(res => {
        if (res.errCode === 9994) {
          this.$router.replace('/login')
        }
        if (res.errCode === 0) {
          let data = res.data
          this.info.certStatus = data.certStatus
          this.info.name = data.name || '--'
          this.info.phone = data.phone || '--'
          this.info.email = data.email || '--'
          this.info.headImage = data.headImage
          this.info.sex = data.sex
          this.info.idCard = data.idCard || '--'

          if (data.refereeDto) {
            this.info.refereeDto = data.refereeDto
          }
        }
      })
    },
    currentChange(page) {
      this.pageInfo.pageIndex = page
      this.getTrainList()
    },
    currentChange4(page) {
      this.pageInfo4.pageIndex = page
      this.getAdjudicateList()
    },
    getAdjudicateList () {
      if (!this.account && !this.account.idCard) {
        return false
      }
      getJudgmentDetailPage.call(this, {
        idCard: this.account.idCard,
        pageIndex: this.pageInfo4.pageIndex,
        pageSize: this.pageInfo4.pageSize
      }).then(res => {
        if (res.errCode === 9994) {
          this.$router.replace('/login')
        }
        if (res.errCode === 0) {
          let data = res.data
          if (data && data.records && data.records.length) {
            this.pageInfo4.total = data.total
            this.list4 = []
            data.records.forEach(item => {
              this.list4.push(item)
            })
          }
        }
      })
    },
    // 获取培训记录
    getTrainList () {
      if (!this.account && !this.account.idCard) {
        return false
      }
      getTrainDetailPage.call(this, {
        idCard: this.account.idCard,
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize
      }).then(res => {
        if (res.errCode === 9994) {
          this.$router.replace('/login')
        }
        if (res.errCode === 0) {
          let data = res.data
          if (data && data.records && data.records.length) {
            this.pageInfo.total = data.total
            this.list = []
            data.records.forEach(item => {
              this.list.push(item)
            })
          }
        }
      })
    },
    // 学习中心-进入课程
    goCourse (id) {
      this.$router.push('/study/course?id=' + id)
    },
    // 学习中心-查看培训证书
    goCertificate (id) {
      this.$router.push('/study/certificate?courseId=' + id)
    },
    currentChange5 (page) {
      this.pageInfo5.pageIndex = page
      this.getStudyList()
    },
    // 学习中心-课程列表 + 考试状态 + 各课程观看汇总
    getStudyList () {
      if (!this.account || !this.account.id) {
        return false
      }
      getStudyCourseList.call(this, {
        pageIndex: this.pageInfo5.pageIndex,
        pageSize: this.pageInfo5.pageSize
      }).then(res => {
        if (res.errCode === 9994) {
          this.$router.replace('/login')
        }
        if (res.errCode === 0) {
          const data = res.data
          const records = (data && data.records) || []
          this.pageInfo5.total = data ? data.total : 0
          this.studyCourses = records.map(r => ({
            id: r.id,
            courseName: r.courseName,
            coverImg: r.coverImg,
            lecturer: r.lecturer,
            startTime: r.startTime,
            endTime: r.endTime,
            watchedNum: 0,
            totalNum: 0,
            learnedFlag: 0,
            videoDone: false,
            progress: 0,
            attemptCount: 0,
            latestScore: null,
            latestPassFlag: null,
            lastSubmitTime: null,
            examDone: false,
            done: false
          }))
          this.fillStudyStatuses()
        }
      })
    },
    // 合并考试通过状态 + 各课程视频观看进度
    fillStudyStatuses () {
      const accountId = this.account.id
      // 考试通过状态（全部课程一次返回）
      getStudyUserPassStatus.call(this, { accountId }).then(res => {
        if (res.errCode === 9994) {
          this.$router.replace('/login')
        }
        if (res.errCode === 0 && Array.isArray(res.data)) {
          const map = {}
          res.data.forEach(s => { map[s.courseId] = s })
          this.studyCourses.forEach(c => {
            const s = map[c.id]
            if (s) {
              c.attemptCount = s.attemptCount || 0
              c.latestScore = s.latestScore
              c.latestPassFlag = s.latestPassFlag
              c.lastSubmitTime = s.lastSubmitTime
            }
            c.examDone = c.latestPassFlag === 1
            c.done = c.videoDone && c.examDone
          })
        }
      })
      // 各课程观看汇总（按 accountId 过滤出当前用户行）
      this.studyCourses.forEach(c => {
        getStudyCourseSummary.call(this, { courseId: c.id }).then(res => {
          if (res.errCode === 0 && res.data && Array.isArray(res.data.records)) {
            const mine = res.data.records.find(u => u.accountId === accountId)
            if (mine) {
              c.watchedNum = mine.watchedNum || 0
              c.totalNum = mine.totalNum || 0
              c.learnedFlag = mine.learnedFlag
            } else if (res.data.records[0]) {
              c.totalNum = res.data.records[0].totalNum || 0
            }
            // 无视频视为已满足视频学习要求
            c.videoDone = c.totalNum === 0 ? true : (c.watchedNum >= c.totalNum)
            c.progress = c.totalNum > 0 ? Math.round((c.watchedNum / c.totalNum) * 100) : 0
            c.done = c.videoDone && c.examDone
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.h5-slide {
  display: none;
}
.h5-slide i {
  display: none;
}
.slide {
  float: left;
  width: 25%;
  box-sizing: border-box;
  border: solid 1px #ddd;
}
.slide h3 {
  color: #2e2e2e;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  line-height: 56px;
}
.slide h3 i {
  color: #ddd;
}
.slide ul li {
  text-align: center;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
  border-top: solid 1px #ddd;
}
.slide ul li.action {
  color: #fff;
  background-color: #4c2ac9;
}
.container-width {
  height: auto;
  overflow: hidden;
  padding-top: 24px;
}
.userinfo {
  float: right;
  width: calc(75% - 20px);
  box-sizing: border-box;
  border: solid 1px #ddd;
  padding: 24px;
  padding-top: 0;
  min-height: 50vh;
}
.userinfo .title {
  font-size: 18px;
  height: 56px;
  line-height: 56px;
  border-bottom: solid 1px #ddd;
  position: relative;
  padding-left: 18px;
}

.userinfo .title::before {
  position: absolute;
  content: '';
  left: 0;
  top: 16px;
  width: 6px;
  height: 24px;
  border-radius: 3px;
  background-color: #1e88e5;
}

.avtar {
  width: 100px;
  height: 100px;
  position: relative;
}
.avtar .img {
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 28px;
  text-align: center;
  border-radius: 50%;
  object-fit: cover;
}
.avtar .edit {
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.32);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  line-height: 100px;
  text-align: center;
  z-index: 100;
  display: none;
}
.avtar:hover .edit {
  cursor: pointer;
  font-size: 24px;
  color: #fff;
  display: block;
}
.avtar .edit ::v-deep .el-upload-list {
  display: none;
}
.userinfo .user {
  color: #666;
  max-width: 280px;
  padding: 16px 0
}
.userinfo .user li {
  padding: 12px 0;
  line-height: 32px;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
}
.userinfo .user li label {
  width: 86px;
  text-align: right;
}
.userinfo .user li .line {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  width: calc(100% - 86px);
  box-sizing: border-box;
}
.blue {
  color: #4c2ac9;
}
.green {
  color: #4caf50;
}
img { vertical-align: middle; }
.userinfo .box {
  padding: 24px;
}
.list {
  min-height: 300px;
}
.userinfo .list ul {
  height: auto;
  overflow: hidden;
  padding: 12px 0;
  display: block;
  width: 100%;
}
.userinfo .list ul li {
  box-sizing: border-box;
  border: solid 1px #ddd;
  display: block;
  width: 50%;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  float: left;
  padding: 0 12px;
  margin: 6px 0;
}

.empty {
  font-size: 16px;
  color: #888;
  padding: 100px;
  text-align: center;
}

@media screen and (max-width: 1000px) {
.userinfo .list ul li {
  height: auto;
  width: 100%;
}
}
.out-log {
  display: inline-block;
  padding: 6px 12px;
  border: solid 1px #ddd;
  border-radius: 3px;
  color: #666;
  font-size: 12px;
  transition: all ease .1s;
  margin-left: 10px;
}
.out-log:hover {
  border-color:#4c2ac9;
  background-color: #4c2ac9;
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4c2ac9;
}
em {
  font-style: normal;
}

.a-pic {
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 600px;
  height: 425px;
  background: url(../../../../assets/images/bg.jpg) center center no-repeat;
}
.a-pic .wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.a-pic .t1 {
  text-align: left;
  font-size: 14px;
  padding:36px 0 60px 36px;

}
.a-pic .h3 {
  line-height: 42px;
  font-size: 28px;
  text-align: center;
}
.a-pic .mun {
  position: relative;
  font-size: 12px;
  margin-top: 76px;
}

.a-pic .mun span {
  min-width: 64px;
  padding: 0 12px 10px 12px;
  color: #4c4f4d;
  border-bottom: solid 1px #4c4f4d;
  position: absolute;
}
.a-pic .mun .n1 {
  left: 100px;
}
.a-pic .mun .n2 {
  left: 380px;
}
.a-pic .t2 {
  font-size: 18px;
  padding-top: 10px;
}
.a-pic .logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
}
.a-pic .z {
  position: absolute;
  right: 45px;
  bottom: 68px;
  z-index: 10;
}
::v-deep .el-table td.el-table__cell div {
  min-height: 22px;
  line-height: 22px;
}
.h5-list {
  display: none;
}
@media screen and (max-width: 800px) {
  .slide {
    display: none;
  }
  .h5-slide {
    display: block;
  }
  .h5-slide h3 {
    font-size: 18px;
    height: 44px;
    line-height: 44px;
    position: relative;
    padding-left: 12px;
  }
  .h5-slide h3::before {
    position: absolute;
    content: '';
    left: 0;
    top: 10px;
    width: 3px;
    height: 24px;
    border-radius: 3px;
    background-color: #4c2ac9;
  }
  .h5-slide ul {
    height: 44px;
    line-height: 44px;
    display: block;
    border-bottom: solid 3px #a8a8a8;
  }
  .h5-slide ul li {
    width: 25%;
    font-size: 14px;
    text-align: center;
    float: left;
    color: #a7a7a7;
  }
  .h5-slide ul li.action {
    position: relative;
    font-size: 18px;
    font-weight: normal;
    color: #333;
  }
  .h5-slide ul li.action::after {
    position: absolute;
    left: 0;
    bottom: -3px;
    width: 100%;
    height: 3px;
    background: #4c2ac9;
    content: '';
  }
  .userinfo {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    border: none;
  }
  .userinfo .title {
    display: none;
  }
  .container-width {
    padding: 12px 16px 24px 16px;
  }

  .avtar .img {
    background-color: rgba(0, 0, 0, 0.03)
  }
  .userinfo .user {
    padding-left: 6px;
    padding-top: 24px;
    max-width: 100%;
  }
  .userinfo .user li {
    padding: 3px 0;
  }
  .userinfo .user li label {
    color: #333;
    text-align: left;
  }
  .userinfo .user li .line {
    color: #666;
  }
  .out-log {
    margin-top: 36px;
    text-align: center;
    border-radius: 20px;
    padding: 12px 24px;
    font-size: 14px;
    box-sizing: border-box;
    width: 100%;
    margin-left: 0;
  }
  .table {
    display: none;
  }
  .h5-list {
    padding-top: 3px;
    margin-bottom: 24px;
    display: block;
  }
  .h5-list .item {
    font-size: 14px;
    padding: 12px 0 16px 0;
    border-bottom: solid 1px #f2f2f2;
  }
  .h5-list .item .h3 {
    line-height: 24px;
    font-size: 16px;
    color: #333;
    padding: 6px 0;
    color: #333;
  }

  .h5-list .item .h3 span {
    margin-right: 16px;
  }
  .h5-list .item .content {
    padding: 4px 0;
    font-size: 14px;
    line-height: 18px;
    color: #606060;
  }
  .h5-list .item .content .label {
    color: #606060;
    font-weight: bold;
  }
  ::v-deep .el-tag {
    height: 24px;
    line-height: 24px;
  }
}

/* 学习中心 */
.study-wrap {
  padding: 16px 0;
}
.study-tip {
  font-size: 13px;
  color: #888;
  line-height: 22px;
  padding: 10px 14px;
  background: #f6f4ff;
  border-radius: 4px;
  margin-bottom: 16px;
}
.course-card {
  border: solid 1px #ece8ff;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 14px;
  transition: all ease .15s;
  overflow: hidden;
}
.course-card:hover {
  border-color: #4c2ac9;
  box-shadow: 0 4px 14px rgba(76, 42, 201, .12);
}
.course-card .cc-cover {
  position: relative;
  margin: -16px -18px 14px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  height: 140px;
  background: #f3eeff;
}
.course-card .cc-cover .el-image {
  width: 100%;
  height: 140px;
  display: block;
}
.course-card .cc-cover .cc-cover-err {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  color: #ccc;
  font-size: 36px;
}
.course-card .cc-cover .cc-cover-tag {
  position: absolute;
  top: 10px;
  right: 10px;
}
.course-card .cc-lecturer {
  color: #666;
  font-size: 13px;
  margin-top: 6px;
}
.course-card .cc-lecturer i {
  margin-right: 4px;
  color: #4c2ac9;
}
.course-card .cc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.course-card .cc-name {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}
.course-card .cc-meta {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
}
.course-card .cc-meta i {
  margin-right: 4px;
}
.course-card .cc-body {
  margin-top: 12px;
  border-top: dashed 1px #f0f0f0;
  padding-top: 12px;
}
.course-card .cc-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
  padding: 4px 0;
}
.course-card .cc-item .label {
  width: 70px;
  color: #999;
}
.course-card .cc-item .num {
  color: #666;
  margin-left: 10px;
}
.course-card .cc-item .bar {
  flex: 1;
  max-width: 160px;
  margin-left: 12px;
}
.course-card .cc-foot {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #4c2ac9;
  font-size: 13px;
}
@media screen and (max-width: 800px) {
  .study-tip {
    font-size: 12px;
  }
  .course-card .cc-item .bar {
    max-width: 90px;
  }
}
</style>
